module.exports = __webpack_public_path__ + "img/nike_logo_de.de3621e6.svg";